function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Strom icon",
  transform: "translate(1959 -1260.7)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 55.3,
  cy: 51.7,
  className: "cls-99",
  "data-name": "Ellipse 14",
  rx: 55.3,
  ry: 51.7,
  transform: "translate(1529 490.4)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 55.3,
  cy: 51.7,
  className: "cls-99",
  "data-name": "Ellipse 15",
  rx: 55.3,
  ry: 51.7,
  transform: "translate(1569.6 467.8)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55.3,
  cy: 55.3,
  r: 55.3,
  className: "cls-99",
  "data-name": "Ellipse 16",
  transform: "translate(1618.9 476.8)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 55.3,
  cy: 51.7,
  className: "cls-99",
  "data-name": "Ellipse 17",
  rx: 55.3,
  ry: 51.7,
  transform: "translate(1631.8 450)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 55.3,
  cy: 51.7,
  className: "cls-99",
  "data-name": "Ellipse 18",
  rx: 55.3,
  ry: 51.7,
  transform: "translate(1687.1 477.5)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 55.3,
  cy: 51.7,
  className: "cls-99",
  "data-name": "Ellipse 19",
  rx: 55.3,
  ry: 51.7,
  transform: "translate(1709.6 507.3)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55.3,
  cy: 55.3,
  r: 55.3,
  className: "cls-99",
  "data-name": "Ellipse 20",
  transform: "translate(1639.6 500.1)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 55.3,
  cy: 51.7,
  className: "cls-99",
  "data-name": "Ellipse 21",
  rx: 55.3,
  ry: 51.7,
  transform: "translate(1569.6 507.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fd0",
  strokeWidth: 18,
  d: "M1732.5 644l-61.4-61.4 22.5-10.3 26.8 5.1 9.5-22.4-38-37.2",
  "data-name": "Path 59"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fd0",
  strokeWidth: 15,
  d: "M1597.2 539.5l31.2 25.9-24.8 22.2 17.3 36.2",
  "data-name": "Path 60"
}));

function SvgStorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3487.9 -810.7 291.2 200.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorm);
export default __webpack_public_path__ + "static/media/storm.3cc98843.svg";
export { ForwardRef as ReactComponent };